import { render, staticRenderFns } from "./ProcedimientoView.vue?vue&type=template&id=46d94842"
import script from "./ProcedimientoView.vue?vue&type=script&lang=js"
export * from "./ProcedimientoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports